import { ReactNode } from 'react';

import { StyledBreadcrumbs } from './Breadcrumbs.styled';
import { BreadcrumbsItem, BreadcrumbsItemProps } from './BreadcrumbsItem';

export interface BreadcrumbsProps {
  items: BreadcrumbsItemProps[];
  separator?: ReactNode;
}

export const Breadcrumbs = (props: BreadcrumbsProps) => {
  return (
    <StyledBreadcrumbs
      aria-label="breadcrumb"
      data-testid="breadcrumbs"
      separator={props.separator}>
      {props.items.map((item, index) => (
        <BreadcrumbsItem key={index} props={props} item={item} index={index} />
      ))}
    </StyledBreadcrumbs>
  );
};
